module.exports = __webpack_public_path__ + "static/shop1-e707df26d23f8b760fd0c5240220e073.jpg";